<template>
  <LmDialog v-model="showModal" :title="title" :styles="{ minWidth: '1200px' }">
    <template #toolbar-actions>
      <q-btn size="sm" color="tertiary" class="q-mr-sm" :label="modalLabel" :loading="isLoading" @click="onSave" />
    </template>

    <template #content>
      <q-card-section class="fields">
        <div v-for="field in fields" :key="field.name">
          <LmDatePicker
            v-if="field.data_type === 'date'"
            v-model="data[field.name]"
            :label="field.label"
            :options="validToPickerOptions(field.name)"
            :disable="disableValidTo(field.name)"
          />
          <q-input
            v-else
            :ref="`input-${field.name}`"
            v-model="data[field.name]"
            :rules="inputRule(field.name)"
            :label="`${field.label} ${field.name === 'publication_title' ? '*' : ''}`"
            outlined
          />
        </div>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import * as apiTo from '../../api'
// Libraries
import moment from 'moment'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import LmDatePicker from '@/reusable/LmDatePicker/LmDatePicker'

export default {
  components: {
    LmDialog,
    LmDatePicker
  },

  data: () => ({
    showModal: false,
    fields: [],
    data: null,
    isLoading: false,
    editMode: false
  }),

  computed: {
    title() {
      if (!this.editMode) return 'Add title'
      return 'Edit title'
    },

    modalLabel() {
      if (this.editMode) return 'Update'
      return 'Save'
    }
  },

  methods: {
    getDateForBE(date) {
      if (!date) return null
      return moment(date, this.settings.date_format).format(this.globalVarsAndFns.BEdateFormat)
    },

    getDateForFE(date) {
      if (!date) return null
      return moment(date, this.globalVarsAndFns.BEdateFormat).format(this.settings.date_format)
    },

    disableValidTo(field) {
      if (field !== 'valid_to') return false
      return !this.data.valid_from
    },

    inputRule(field) {
      if (field !== 'publication_title') return [true]
      return [val => !!val || 'required']
    },

    validToPickerOptions(field) {
      if (field !== 'valid_to') return
      return date => moment(date, 'YYYY/MM/DD').isSameOrAfter(moment(this.data.valid_from, 'DD/MM/YYYY'))
    },

    getData(fields, rowData) {
      if (rowData)
        // when we are in edit modal
        return {
          ...rowData,
          valid_from: this.getDateForFE(rowData.valid_from),
          valid_to: this.getDateForFE(rowData.valid_to)
        }

      // build data from fields for create modal
      return fields.reduce((acc, curr) => {
        acc[curr.name] = null
        return acc
      }, {})
    },

    // to be accessed from the parent component
    open(fields, rowData) {
      this.editMode = !!rowData
      this.fields = fields
      this.data = this.getData(fields, rowData)
      this.showModal = true
    },

    onSave() {
      if (!this.$refs['input-publication_title'][0].validate()) return
      const eventName = !!this.editMode ? 'row-updated' : 'row-added'
      const apiName = !!this.editMode ? 'updatePublication' : 'createPublication'
      const dataId = !!this.editMode ? this.data.id : this.$route.params.id
      const data = {
        ...this.data,
        valid_from: this.getDateForBE(this.data.valid_from),
        valid_to: this.getDateForBE(this.data.valid_to)
      }

      this.makeRequest(eventName, apiName, dataId, data)
    },

    makeRequest(eventName, apiName, dataId, data) {
      this.isLoading = true

      apiTo[apiName](dataId, data)
        .then(({ data }) => {
          this.$emit(eventName, data.result)
          this.showModal = false
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="stylus" scoped>
.fields {
  display grid
  grid-template-columns repeat(auto-fit, minmax(250px, 1fr))
  gap 15px
}
</style>
